import React, { useState } from 'react';
import { Button, Form, Input, message, Result } from 'antd';
import { UpdatePassword } from '../../apis/Brand/Profile/UpdatePassword';
import { Link } from 'react-router-dom';
// import { UserOutlined, MailOutlined} from '@ant-design/icons';

const { Item } = Form;
const BrandNewPasswordFormComponent = ({ resetEmail }) => {
  const [brandNewPassword] = Form.useForm();
  const [resetState, setResestState] = useState({
    success: false,
  });
  const onFinish = (values) =>{
    const _data = {
      email: resetEmail,
      token: values.token,
      newpassword: values.password,
    };
    UpdatePassword(_data).then(({ response, status })=>{
      if (status === 200) {
        console.log('res', response);
        setResestState({
          ...resetState,
          success: true,
        });
      } else {
        console.log('res', response);
        message.error('There is some issue with reseting password');
      }
    });
  };
  return (
    <div>
      {
        !resetState.success ?(
          <>
            <Form
              form={brandNewPassword}
              name="brandResetPassword"
              layout="vertical"
              className="login-form pt-2"
              autoComplete="off"
              requiredMark={false}
              onFinish={onFinish}
            >
              <Item
                label="Enter token recevied on yor Email"
                name="token"
                rules={[
                  { required: true, message: 'Please provide recevied token' },
                ]}
              >
                <Input size="large"
                  type="text"
                  placeholder="eg: 5zGb95WcioSawh8aV7bY2YQT"/>
              </Item>
              <Item
                className="mt-1"
                name="password"
                rules={[
                  { required: true, message: 'Password can\'t be empty' },
                  // {min:6,message:"minmum 6 characters needed"}
                ]}
                hasFeedback
              >
                <Input.Password size="large"
                  placeholder="New password"/>
              </Item>
              <Item
                className="mt-1"
                name="confirmPassword"
                dependencies={['password']}
                hasFeedback
                rules={[
                  { required: true, message: 'Official email id can\'t be empty' },
                  ({ getFieldValue }) => ({
                    validator (_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Password not matching'));
                    },
                  }),
                ]}
              >
                <Input.Password size="large"
                  placeholder="Confirm Password"/>
              </Item>
              <Item
                className="mt-1"
              >
                <Button htmlType="submit"
                  className="common_button">Reset Password</Button>
              </Item>
            </Form>
          </>
        ):(
          <Result
            status="success"
            title="Password updated successfully!"
            subTitle="Now you can go back and Signin with newly created password"
            extra={[
              <Link key="signin"
                to="/signin/brand-agency">
                <Button className="common_button">
                                    Signin
                </Button>
              </Link>,
            ]}
          />
        )
      }
    </div>
  );
};

export default BrandNewPasswordFormComponent;
